import { render, staticRenderFns } from "./stationCheckAdd.vue?vue&type=template&id=2882300c&scoped=true&"
import script from "./stationCheckAdd.vue?vue&type=script&lang=js&"
export * from "./stationCheckAdd.vue?vue&type=script&lang=js&"
import style0 from "./stationCheckAdd.vue?vue&type=style&index=0&id=2882300c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2882300c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2882300c')) {
      api.createRecord('2882300c', component.options)
    } else {
      api.reload('2882300c', component.options)
    }
    module.hot.accept("./stationCheckAdd.vue?vue&type=template&id=2882300c&scoped=true&", function () {
      api.rerender('2882300c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/oilCheckManage/stationCheckAdd.vue"
export default component.exports